import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { toast } from "react-toastify";
import obterDadosTicket from "../../hooks/obterDadosTicket";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { AccessAlarm } from "@material-ui/icons";
import TimeInput from "../TimeInput";
import FormatTime from "../../helpers/FormatTime";

const filterOptions = createFilterOptions({
  trim: true,
});

const listaMotivoClassificacao = [
  "Dúvida",
  "Erro",
  "Treinamento",
  "Desenvolver",
  "Configurar",
  "Outros",
  "Atualizar",
];

const EditarTicketModal = ({
  modalOpen,
  onClose,
  onSubmit,
  ticketid,
  tituloBotaoSubmit,
}) => {
  // #region Pessoa
  const [optionsPessoa, setOptionsPessoa] = useState([]);
  const [textoPesquisaPessoa, setTextoPesquisaPessoa] = useState("");
  const [pessoaSelecionada, setPessoaSelecionada] = useState(null);
  // #endregion Pessoa

  // #region PlataformaSistema
  const [optionsPlataformaSistema, setOptionsPlataformaSistema] = useState([]);
  const [textoPesquisaPlataformaSistema, setTextoPesquisaPlataformaSistema] =
    useState("");
  const [plataformaSistemaSelecionada, setPlataformaSistemaSelecionada] =
    useState(null);
  // #endregion PlataformaSistema

  // #region ModuloFuncionalidade
  const [optionsModuloFuncionalidade, setOptionsModuloFuncionalidade] =
    useState([]);
  const [
    textoPesquisaModuloFuncionalidade,
    setTextoPesquisaModuloFuncionalidade,
  ] = useState("");
  const [moduloFuncionalidadeSelecionada, setModuloFuncionalidadeSelecionada] =
    useState(null);
  // #endregion ModuloFuncionalidade

  // #region SlaPrioridade
  const [optionsSlaPrioridade, setOptionsSlaPrioridade] = useState([]);
  const [textoPesquisaSlaPrioridade, setTextoPesquisaSlaPrioridade] =
    useState("");
  const [slaPrioridadeSelecionada, setSlaPrioridadeSelecionada] =
    useState(null);
  // #endregion SlaPrioridade

  // #region MotivoClassificacao
  const [motivoClassificacaoSelecionada, setMotivoClassificacaoSelecionada] =
    useState(null);
  // #endregion MotivoClassificacao

  // #region Campos Textos Descricao
  const [textoDescricao, setTextoDescricao] = useState("");
  const [textoDescricaoCompleta, setTextoDescricaoCompleta] = useState("");
  const [textoDescricaoInterna, setTextoDescricaoInterna] = useState("");
  // #endregion Campos Textos Descricao

  // #region TempoInicioFim
  const [tempoInicioFim, setTempoInicioFim] = useState(null);
  // #endregion TempoInicioFim

  // #region TempoInicioFimAjustado
  const [tempoInicioFimAjustado, setTempoInicioFimAjustado] = useState(null);
  // #endregion TempoInicioFimAjustado

  // #region TempoReal
  const [tempoReal, setTempoReal] = useState(null);
  // #endregion TempoReal

  const [loading, setLoading] = useState(false);
  const { findById } = obterDadosTicket();

  const { user: loggedInUser } = useContext(AuthContext);

  useEffect(() => {
    const carregarTicket = async () => {
      const response = await findById(ticketid);
      setPessoaSelecionada(
        response.pessoa
          ? response.pessoa
          : { id: null, nomeFantasia: "", nomeRazaoSocial: "" }
      );
      setTextoDescricao(response.descricao);
      setPlataformaSistemaSelecionada(
        response.plataformaSistema
          ? response.plataformaSistema
          : { id: null, descricao: "" }
      );
      setModuloFuncionalidadeSelecionada(
        response.moduloFuncionalidade
          ? response.moduloFuncionalidade
          : { id: null, descricao: "" }
      );
      setSlaPrioridadeSelecionada(
        response.slaPrioridade
          ? response.slaPrioridade
          : { id: null, descricao: "" }
      );

      setMotivoClassificacaoSelecionada(response.motivoClassificacao);
      setTextoDescricaoCompleta(response.descricaoCompleta);
      setTextoDescricaoInterna(response.descricaoInterna);
      setTempoInicioFim(FormatTime(response.tempoInicioFim));
      setTempoInicioFimAjustado(FormatTime(response.tempoInicioFimAjustado));
      setTempoReal(FormatTime(response.tempoReal));
    };
    carregarTicket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketid, modalOpen]);

  // #region Change dos AutoCompletes...
  useEffect(() => {
    if (!modalOpen || textoPesquisaPessoa.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-pessoa/", {
            params: { texto: textoPesquisaPessoa },
          });

          setOptionsPessoa(data.pessoas);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaPessoa, modalOpen]);

  useEffect(() => {
    if (!modalOpen || textoPesquisaPlataformaSistema.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-plataformasistema/", {
            params: { texto: textoPesquisaPlataformaSistema },
          });

          setOptionsPlataformaSistema(data.plataformaSistema);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaPlataformaSistema, modalOpen]);

  useEffect(() => {
    if (!modalOpen || textoPesquisaModuloFuncionalidade.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get(
            "/autocomplete-modulofuncionalidade/",
            {
              params: { texto: textoPesquisaModuloFuncionalidade },
            }
          );

          setOptionsModuloFuncionalidade(data.moduloFuncionalidade);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaModuloFuncionalidade, modalOpen]);

  useEffect(() => {
    if (!modalOpen || textoPesquisaSlaPrioridade.length < 0) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocomplete-slaprioridade/", {
            params: { texto: textoPesquisaSlaPrioridade },
          });

          setOptionsSlaPrioridade(data.slaPrioridade);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaSlaPrioridade, modalOpen]);
  // #endregion Change dos AutoCompletes...

  const handleClose = () => {
    onClose();
    setTextoPesquisaPessoa("");
    setTextoPesquisaPlataformaSistema("");
    setTextoPesquisaModuloFuncionalidade("");
    setTextoPesquisaSlaPrioridade("");
    setPessoaSelecionada(null);
    setPlataformaSistemaSelecionada(null);
    setModuloFuncionalidadeSelecionada(null);
    setMotivoClassificacaoSelecionada("");
    setSlaPrioridadeSelecionada(null);
    setTextoDescricao("");
    setTextoDescricaoCompleta("");
    setTextoDescricaoInterna("");
    setTempoInicioFim(null);
    setTempoInicioFimAjustado(null);
    setTempoReal(null);
  };

  const handleSaveTicket = async (e) => {
    e.preventDefault();
    if (!ticketid) return;
    setLoading(true);
    try {
      let data = {};
      data.idPessoa = pessoaSelecionada ? pessoaSelecionada.id : null;
      data.descricao = textoDescricao ?? null;
      data.idPlataformaSistema = plataformaSistemaSelecionada
        ? plataformaSistemaSelecionada.id
        : null;
      data.idModuloFuncionalidade = moduloFuncionalidadeSelecionada
        ? moduloFuncionalidadeSelecionada.id
        : null;
      data.motivoClassificacao =
        motivoClassificacaoSelecionada === undefined
          ? null
          : motivoClassificacaoSelecionada;
      data.idSlaPrioridade = slaPrioridadeSelecionada
        ? slaPrioridadeSelecionada.id
        : null;
      data.descricaoCompleta = textoDescricaoCompleta ?? null;
      data.descricaoInterna = textoDescricaoInterna ?? null;
      data.tempoInicioFim = tempoInicioFim || null;
      data.tempoInicioFimAjustado = tempoInicioFimAjustado || null;
      data.tempoReal = tempoReal || null;

      await api.put(`/tickets/${ticketid}`, data);

      setLoading(false);
      onSubmit(data);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error);
    }
  };

  const handleSugerirSlaPrioridade = async (campoOrigem, valorAtual) => {
    setLoading(true);
    try {
      let data = {};

      if (valorAtual) {
        if (campoOrigem === "motivo" && moduloFuncionalidadeSelecionada.id) {
          data.motivoClassificacaoBuscar = valorAtual;
          data.idModuloFuncionalidadeBuscar =
            moduloFuncionalidadeSelecionada.id;
        } else if (campoOrigem === "modulo" && motivoClassificacaoSelecionada) {
          data.motivoClassificacaoBuscar = motivoClassificacaoSelecionada;
          data.idModuloFuncionalidadeBuscar = valorAtual.id;
        }
      }

      if (
        data &&
        Object.keys(data).length > 0 &&
        data.idModuloFuncionalidadeBuscar &&
        data.motivoClassificacaoBuscar
      ) {
        const retornoSlaPrioridade = await api.get("/obter-slaprioridade/", {
          params: data,
        });
        setSlaPrioridadeSelecionada(retornoSlaPrioridade.data);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error);
    }
  };

  const handleCalcularTempo = async () => {
    setLoading(true);
    try {
      const { data: retornoCalculoTempoTicket } = await api.get(
        `/tickets-calcular-tempo/${ticketid}`
      );

      setTempoInicioFim(retornoCalculoTempoTicket.tempoInicioFim);
      setTempoInicioFimAjustado(
        retornoCalculoTempoTicket.tempoInicioFimAjustado
      );
      setTempoReal(retornoCalculoTempoTicket.tempoReal);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.response.data.error);
    }
  };

  return (
    <Dialog open={modalOpen} onClose={handleClose} maxWidth="xl" scroll="paper">
      <form onSubmit={handleSaveTicket}>
        <DialogTitle id="form-dialog-title">
          Editar Ticket - #{ticketid}
        </DialogTitle>
        <DialogContent
          dividers="paper"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Autocomplete
            style={{ flex: 1, marginBottom: 10 }}
            getOptionLabel={(option) =>
              `${
                option.nomeFantasia ||
                option.nomeRazaoSocial ||
                pessoaSelecionada.nomeFantasia ||
                pessoaSelecionada.nomeRazaoSocial
              }`
            }
            onChange={(e, newValue) => {
              setPessoaSelecionada(newValue);
            }}
            id="pessoaSelecionada"
            name="pessoaSelecionada"
            value={pessoaSelecionada}
            options={optionsPessoa}
            filterOptions={filterOptions}
            freeSolo
            autoHighlight
            noOptionsText="Nenhuma opção encontrada..."
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Digite para buscar um cliente"
                variant="outlined"
                onChange={(e) => setTextoPesquisaPessoa(e.target.value)}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
                margin="dense"
              />
            )}
          />
          <TextField
            style={{ flex: 1, marginBottom: 10 }}
            id="descricao"
            name="descricao"
            label={"Descrição do Ticket"}
            variant="outlined"
            value={textoDescricao}
            autoFocus
            onChange={(e) => setTextoDescricao(e.target.value)}
            inputProps={{ maxLength: 100 }}
            margin="dense"
          />
          <div
            style={{
              display: "flex",
              gap: "15px",
              width: "100%",
            }}
          >
            <Autocomplete
              style={{ flex: 1, marginBottom: 10 }}
              getOptionLabel={(option) =>
                `${option.descricao || plataformaSistemaSelecionada.descricao}`
              }
              onChange={(e, newValue) => {
                setPlataformaSistemaSelecionada(newValue);
              }}
              id="plataformaSistemaSelecionada"
              name="plataformaSistemaSelecionada"
              value={plataformaSistemaSelecionada}
              options={optionsPlataformaSistema}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Plataforma ou sistema"
                  variant="outlined"
                  onChange={(e) =>
                    setTextoPesquisaPlataformaSistema(e.target.value)
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                  margin="dense"
                />
              )}
            />
            <Autocomplete
              style={{ flex: 1, marginBottom: 10 }}
              getOptionLabel={(option) =>
                `${
                  option.descricao || moduloFuncionalidadeSelecionada.descricao
                }`
              }
              onChange={async (e, newValue) => {
                setModuloFuncionalidadeSelecionada(newValue);
                await handleSugerirSlaPrioridade("modulo", newValue);
              }}
              id="moduloFuncionalidadeSelecionada"
              name="moduloFuncionalidadeSelecionada"
              value={moduloFuncionalidadeSelecionada}
              options={optionsModuloFuncionalidade}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Modulo ou funcionalidade"
                  variant="outlined"
                  onChange={(e) =>
                    setTextoPesquisaModuloFuncionalidade(e.target.value)
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                  margin="dense"
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "15px",
              width: "100%",
            }}
          >
            <Autocomplete
              style={{ flex: 1, marginBottom: 10 }}
              id="motivoClassificacao"
              name="motivoClassificacao"
              label="Motivo (Classificação)"
              variant="outlined"
              value={motivoClassificacaoSelecionada}
              onChange={async (e, newValue) => {
                setMotivoClassificacaoSelecionada(newValue);
                await handleSugerirSlaPrioridade("motivo", newValue);
              }}
              options={listaMotivoClassificacao.map((motivo) => motivo)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Motivo (Classificação)"
                  variant="outlined"
                  margin="dense"
                />
              )}
            />
            <Autocomplete
              style={{ flex: 1, marginBottom: 10 }}
              getOptionLabel={(option) =>
                `${option.descricao || slaPrioridadeSelecionada.descricao}`
              }
              onChange={(e, newValue) => {
                setSlaPrioridadeSelecionada(newValue);
              }}
              id="slaPrioridadeSelecionada"
              name="slaPrioridadeSelecionada"
              value={slaPrioridadeSelecionada}
              options={optionsSlaPrioridade}
              filterOptions={filterOptions}
              freeSolo
              autoHighlight
              noOptionsText="Nenhuma opção encontrada..."
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Digite para buscar um sla"
                  variant="outlined"
                  onChange={(e) =>
                    setTextoPesquisaSlaPrioridade(e.target.value)
                  }
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                  margin="dense"
                />
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "15px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <TimeInput
              style={{ flex: 1, marginBottom: 10 }}
              label={"Tempo total (Inicio / Fim)"}
              name="tempoInicioFim"
              value={tempoInicioFim}
              onChange={(e) => setTempoInicioFim(e)}
              margin="dense"
              variant="outlined"
              disabled
            />
            <TimeInput
              style={{ flex: 1, marginBottom: 10 }}
              label={"Tempo total ajustado"}
              name="tempoInicioFimAjustado"
              value={tempoInicioFimAjustado}
              onChange={(e) => setTempoInicioFimAjustado(e)}
              margin="dense"
              variant="outlined"
              disabled
            />
            <TimeInput
              style={{ flex: 1, marginBottom: 10 }}
              label={"Tempo real"}
              name="tempoReal"
              value={tempoReal}
              onChange={(e) => setTempoReal(e)}
              margin="dense"
              variant="outlined"
            />
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{
                width: 40,
                height: 40,
                marginBottom: 10,
                marginTop: 10,
              }}
              onClick={handleCalcularTempo}
            >
              <AccessAlarm />
            </Button>
          </div>
          <TextField
            style={{ flex: 1, marginBottom: 10 }}
            id="descricaoCompleta"
            name="descricaoCompleta"
            label={"Descrição Completa"}
            variant="outlined"
            value={textoDescricaoCompleta}
            onChange={(e) => setTextoDescricaoCompleta(e.target.value)}
            inputProps={{ maxLength: 1000 }}
            margin="dense"
            multiline
            maxRows={5}
          />
          <TextField
            style={{ flex: 1, marginBottom: 10 }}
            id="descricaoInterna"
            name="descricaoInterna"
            label={"Descrição Interna"}
            variant="outlined"
            value={textoDescricaoInterna}
            onChange={(e) => setTextoDescricaoInterna(e.target.value)}
            inputProps={{ maxLength: 1000 }}
            margin="dense"
            multiline
            maxRows={5}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            disabled={loading}
            variant="outlined"
          >
            Cancelar
          </Button>
          <ButtonWithSpinner
            variant="contained"
            type="submit"
            color="primary"
            loading={loading}
          >
            {tituloBotaoSubmit}
          </ButtonWithSpinner>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditarTicketModal;
